import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Sanitiza termo de busca para uso seguro em filtros PostgREST (.or(), .ilike())
 * Remove caracteres com significado especial na sintaxe de filtro do PostgREST
 * para prevenir ataques de injeção de filtro (PostgREST filter injection).
 *
 * Removidos: ',' '(' ')' '\' '%' e null byte.
 * A aplicação adiciona os wildcards '%..%' — o usuário não deve controlá-los.
 */
export function sanitizeSearchQuery(query: string | null | undefined): string {
  if (!query) return "";
  return query.trim().replace(/[,()\\\x00%]/g, "");
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}